import { render } from "./TrackerCreateFirstStep.vue?vue&type=template&id=2caccb57"
import script from "./TrackerCreateFirstStep.vue?vue&type=script&lang=js"
export * from "./TrackerCreateFirstStep.vue?vue&type=script&lang=js"
script.render = render

export default script